import { tv } from 'tailwind-variants';

export const cardStyle = tv({
  slots: {
    base: 'relative rounded-lg border border-solid border-stroke',
    ripple: 'bg-primary/10'
  },
  variants: {
    clickable: {
      true: 'cursor-pointer overflow-hidden'
    }
  }
});
